import { Moment } from "moment";
import { Language } from "./language";
import { SystemUser } from "./system-user";

export class ContactRequestPdfTemplate {

    constructor(
        public name: string,
        public body: string,
        public language: Language,
        public id?: number,
        public created?: Moment,
        public lastModified?: Moment,
        public createdBy?: SystemUser,
        public lastModifiedBy?: SystemUser
    ){}
}
